import { render, staticRenderFns } from "./ShipmentSidebar.vue?vue&type=template&id=3bcbd750&scoped=true&"
import script from "./ShipmentSidebar.vue?vue&type=script&lang=js&"
export * from "./ShipmentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentSidebar.vue?vue&type=style&index=0&id=3bcbd750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcbd750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcbd750')) {
      api.createRecord('3bcbd750', component.options)
    } else {
      api.reload('3bcbd750', component.options)
    }
    module.hot.accept("./ShipmentSidebar.vue?vue&type=template&id=3bcbd750&scoped=true&", function () {
      api.rerender('3bcbd750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/ShipmentSidebar.vue"
export default component.exports